import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/image_1.jpg'


const _hoisted_1 = { class: "joinSection main" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "joinBlock" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "img dotsTop" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "image"
  })
], -1)
const _hoisted_5 = { class: "info" }
const _hoisted_6 = {
  class: "title lg font-prompt",
  style: {"font-size":"30px","letter-spacing":"1px","line-height":"42px"}
}
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "textBlock" }
const _hoisted_9 = { class: "in" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "icon-arrow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.t("joinSection.title")), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("p", null, _toDisplayString(_ctx.t("joinSection.content")), 1)
            ])
          ]),
          _createVNode("a", {
            href: _ctx.registerUrl,
            class: "btnIconType1 sm"
          }, [
            _createVNode("span", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.t("joinSection.start")), 1),
              _hoisted_11
            ])
          ], 8, ["href"])
        ])
      ])
    ])
  ]))
}